export default __webpack_public_path__ + "static/home-banner3-mobile-0d97f3902d3a1f77d33ddb31b3fe9966.jpg";